import React from 'react';

import EmptyPage from '../../components/EmptyPage';
import NewHeader from '../../components/NewHeader';

export default function PrivacyPolicy() {
	const pageContent = `# PRIVACY POLICY\n
	**Privacy Policy**\n
	
	Effective date: November 27, 2017\n
	
	REMILIA HAIR LLC. ("us", "we", or "our") operates the https://www.remiliahair.com website (hereinafter referred\nto as the "Service").\n
	
	This page informs you of our policies regarding the collection, use and disclosure of personal data when you use\nour Service and the choices you have associated with that data.\n
	
	We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of\ninformation in accordance with this policy.\n
	
	**Definitions**\n
	
	**Service**\n
	
	Service is the https://www.remiliahair.com website operated by REMILIA HAIR LLC\n
	
	**Personal Data**\n
	
	Personal Data means data about a living individual who can be identified from those data (or from those and other\ninformation either in our possession or likely to come into our possession).\n
	
	**Usage Data**\n
	
	Usage Data is data collected automatically either generated by the use of the Service or from the Service\ninfrastructure itself (for example, the duration of a page visit).\n
	
	**Cookies**\n
	
	Cookies are small files stored on your device (computer or mobile device).\n
	
	**Data Controller**\n
	
	Data Controller means the natural or legal person who (either alone or jointly or in common with other persons)\ndetermines the purposes for which and the manner in which any personal information are, or are to be, processed.\n
	
	For the purpose of this Privacy Policy, we are a Data Controller of your Personal Data.\n
	
	**Data Processors (or Service Providers)**\n
	
	Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the\nData Controller.\n
	
	We may use the services of various Service Providers in order to process your data more effectively.\n
	
	**Data Subject (or User)**\n
	
	Data Subject is any living individual who is using our Service and is the subject of Personal Data.\n
	
	**Information Collection and Use**\n
	
	We collect several different types of information for various purposes to provide and improve our Service to you.\n
	
	**Types of Data Collected**\n
	
	**Personal Data**\n
	
	While using our Service, we may ask you to provide us with certain personally identifiable information that can\nbe used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:\n
	
	-   Email address\n-   First name and last name\n-   Phone number\n-   Address, State, Province, ZIP/Postal code, City\n-   Cookies and Usage Data\n
	
	We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or the instructions provided in any email we send.\n
	
	**Usage Data**\n
	
	We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.\n
	
	**Location Data**\n
	
	We may use and store information about your location if you give us permission to do so ("Location Data"). We use this data to provide features of our Service, to improve and customize our Service.\n
	
	You can enable or disable location services when you use our Service at any time by way of your device settings.\n
	
	**Tracking Cookies Data**\n
	
	We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.\n
	
	Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.\n
	
	You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.\n
	
	Examples of Cookies we use:\n
	
	-   **Session Cookies.**  We use Session Cookies to operate our Service.\n-   **Preference Cookies.**  We use Preference Cookies to remember your preferences and various settings.\n-   **Security Cookies.**  We use Security Cookies for security purposes.`;
	return (
		<div>
			<EmptyPage text={pageContent} />
		</div>
	);
}
